import React from "react";
import {
  MagnifyingGlassIcon,
  HomeIcon,
  MapPinIcon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/solid";
import {
  BuildingLibraryIcon,
  UserGroupIcon,
  MegaphoneIcon,
  CalendarDaysIcon,
  NewspaperIcon,
  HandThumbUpIcon,
  ChatBubbleOvalLeftIcon,
  ShareIcon,
} from "@heroicons/react/24/outline";

const NewsFeed = () => {

     const feedItems = [
    {
      id: 1,
      user: {
        name: "Wayne County Board",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        postedTime: "2 hours ago"
      },
      image: "https://images.unsplash.com/photo-1519452635265-7b1fbfd1e4e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
      title: "Board Unanimously Approves Renovations for Goldsboro High School Auditorium",
      description: "The Wayne County Board of Education has greenlit a major renovation project for the Goldsboro High School auditorium, a facility that has not been updated since the 1990s. The $4.5 million project will completely overhaul the auditorium's in...",
      likes: 25,
      comments: 32,
      shares: 14
    },
    {
      id: 2,
      user: {
        name: "Sarah Johnson",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        postedTime: "4 hours ago"
      },
           image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",

      title: "Local Community Garden Project Kicks Off This Weekend",
      description: "Join us for the grand opening of the new community garden downtown. We'll have workshops on sustainable farming, free seeds for early birds, and activities for kids. Let's grow together!",
      likes: 48,
      comments: 15,
      shares: 8
    },
    {
      id: 3,
      user: {
        name: "City News Daily",
        image: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        postedTime: "6 hours ago"
      },
        image: "https://images.unsplash.com/photo-1519452635265-7b1fbfd1e4e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",

      title: "Annual Tech Symposium Registration Now Open",
      description: "The city's largest technology event is back! Register now to hear from industry leaders, participate in coding bootcamps, and network with local tech startups. Early bird discounts available.",
      likes: 156,
      comments: 45,
      shares: 89
    }
  ];
  return (
    <div className="overflow-hidden h-screen bg-gray-100 font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-5 h-16 grid grid-cols-12 gap-4 items-center">
          {/* Left: Logo & Search */}
          <div className="col-span-2 flex items-center gap-2">
            <div className="w-12 h-8 bg-indigo-600 rounded-md flex items-center justify-center text-white font-bold">
              {/* Logo Placeholder */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
                />
              </svg>
            </div>
            <div className="relative">
              <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search C2..."
                className="pl-10 pr-4 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:border-indigo-500 w-full"
              />
            </div>
          </div>

          {/* Center: Navigation Icons */}
          <div className="col-span-8 flex items-center justify-center gap-8">
            <button className="p-2 text-indigo-600 hover:bg-gray-50 rounded-full">
              <HomeIcon className="w-6 h-6" />
            </button>
            <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded-full">
              <MapPinIcon className="w-6 h-6" />
            </button>
          </div>

          {/* Right: Sign In */}
          <div className="col-span-2 flex justify-end">
            <button className="w-full flex justify-center  bg-indigo-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 flex items-center gap-2">
              Sign In
              <span>&rarr;</span>
            </button>
          </div>
        </div>
      </header>

      {/* Main Layout */}
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-5 py-6 lg:py-4">
        <div className="grid grid-cols-12 gap-4">
          {/* Left Sidebar (Ads) - fixed, non-scrollable */}
          <div className="hidden lg:block col-span-2">
            <div className="sticky top-20 h-[calc(100vh-6rem)] overflow-hidden space-y-4">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden relative">
              <img
                src={require("../../assets/Ad (5).png")}
                alt="Ad 1"
                className="w-full h-[30vh] object-cover"
              />
              {/* <div className="p-4">
                <h3 className="font-bold text-lg leading-tight mb-2">
                  Build Your Creativity
                </h3>
                <p className="text-xs text-gray-500">13th December | 10 AM</p>
              </div> */}
            </div>
           <div className="bg-white rounded-xl shadow-sm overflow-hidden  relative h-[50vh] flex flex-col justify-center bg-gradient-to-br from-blue-50 to-white">
              {/* <h3 className="text-xl font-bold text-blue-900 mb-2">
                Impactful advertising for your brand.
              </h3>
              <p className="text-sm text-gray-500 mb-4">
                Lorem ipsum dolor sit amet, adipiscing elit, sed.
              </p> */}
              <img
                src={require("../../assets/Ad (4).png")}
                alt="Ad 2"
                className="rounded-lg h-[50vh] object-cover"
              />
            </div>
       

            
            </div>
          </div>

          {/* Center Content - scrollable */}
          <div className="col-span-12 lg:col-span-8">
            <div className="max-h-[calc(100vh-6rem)] overflow-y-auto pr-1 space-y-4">
            <img
                src={require("../../assets/Ad (1).png")}
                alt="Ad 1"
                className="w-full h-[18vh] object-cover rounded-xl"
              />
              <div className="space-y-6 bg-white rounded-xl shadow-sm overflow-hidden">
                {/* Hero Banner */}
                <div className="relative   overflow-hidden h-80  group">
              <img
                src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="County Building"
                className="w-full h-full object-cover"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

              {/* Top Text */}
              <div className="absolute top-6 left-6 max-w-xs">
                <h1 className="text-3xl font-bold text-white leading-tight">
                  Covering Every Corner Of The County
                </h1>
              </div>

              {/* Location Dropdown */}
              <div className="absolute top-6 right-6">
                <button className="bg-white/90 backdrop-blur-sm text-gray-800 px-4 py-2 rounded-md text-sm font-semibold flex items-center gap-2 hover:bg-white">
                  <MapPinIcon className="w-4 h-4 text-green-500" />
                  WAYNE, NC
                  <ChevronDownIcon className="w-4 h-4 text-gray-400" />
                </button>
              </div>

              {/* Bottom Cards */}
              <div className="absolute bottom-6 left-6 right-6 flex gap-40">
                {/* Verse Card */}
                <div className="flex-1 border-[0.5px] border-white bg-[#4E5BA6B2] backdrop-blur-sm rounded-xl p-4 text-white">
                  <div className="flex items-start gap-3">
                    <div className="p-2 bg-white/20 rounded-lg">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-xs uppercase tracking-wider text-indigo-200 mb-1">Verse of the Day</p>
                      <p className="font-bold text-sm">— PSALM 133:1</p>
                      <p className="text-xs mt-2 italic text-indigo-100">"How good and pleasant it is when God's people live together in unity!"</p>
                    </div>
                  </div>
                </div>

                {/* Weather Card */}
                <div className="w-48 bg-[#4E5BA6B2] border-[0.5px] border-white backdrop-blur-sm rounded-xl p-4 text-white flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium">Partly Cloudy</p>
                    <div className="mt-2 text-yellow-400">
                      {/* Sun/Cloud Icon */}
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8">
                        <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
                      </svg>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-indigo-200">Monday</p>
                    <p className="text-xs text-indigo-200">3:00 Pm</p>
                    <p className="text-2xl font-bold mt-1">22°</p>
                    <p className="text-xs text-indigo-200">71.6 F</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links Grid */}
            <div className="bg-white rounded-xl  p-2">
              <div className="grid grid-cols-4 gap-4">
                <div className="flex py-4 hover:rounded-lg hover:bg-indigo-50 flex-col items-center text-center gap-2 group cursor-pointer">
                  <div className="p-3    transition-colors">
                    <BuildingLibraryIcon className="w-8 h-8 text-indigo-600" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700">Official County Meetings</span>
                </div>
                <div className="flex py-4  hover:rounded-lg hover:bg-indigo-50 flex-col items-center text-center gap-2 group cursor-pointer">
                  <div className="p-3    transition-colors">
                    <UserGroupIcon className="w-8 h-8 text-indigo-600" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700">Citizen to Citizen News</span>
                </div>
                <div className="flex py-4  hover:rounded-lg hover:bg-indigo-50 flex-col items-center text-center gap-2 group cursor-pointer">
                  <div className="p-3    transition-colors">
                    <MegaphoneIcon className="w-8 h-8 text-indigo-600" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700">Elected Officials Forms</span>
                </div>
                <div className="flex py-4  hover:rounded-lg hover:bg-indigo-50 flex-col items-center text-center gap-2 group cursor-pointer">
                  <div className="p-3    transition-colors">
                    <NewspaperIcon className="w-8 h-8 text-indigo-600" />
                  </div>
                  <span className="text-xs font-semibold text-gray-700">Local Event Postings</span>
                </div>
              </div>
            </div>

            {/* Search Bar */}
            <div className="relative px-6 py-4 pt-0">
              <MagnifyingGlassIcon className="w-5 h-5 absolute left-9 top-1/3 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search in County..."
                className="w-full pl-12 pr-4 py-2  bg-white border border-gray-400 rounded-md  focus:outline-none focus:border-indigo-500 text-gray-700"
              />
            </div>
          </div>

            {/* News Feed Items */}
            <div className="space-y-6">
              {feedItems.map((item) => (
                <div key={item.id} className="bg-white rounded-xl shadow-sm overflow-hidden">
                    <div className="py-3 px-4  flex items-center gap-3">
                      <div className="p-0.5 bg-white rounded-full">
                        <img
                          src={item.user.image}
                          alt={item.user.name}
                          className="w-11 h-11 rounded-full border-2 border-white object-cover"
                        />
                      </div>
                      <div className="  ">
                        <p className="text-black-500 text-xs font-bold">{item.user.name}</p>
                        <p className="text-gray-400 text-[10px]">{item.user.postedTime}</p>
                      </div>
                    </div>
                  <div className="relative">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-[20rem] object-cover"
                    />
                    {/* User Info Overlay */}
                 
                  </div>
                  
                  <div className="p-6 px-5">
                    <h2 className="text-xl font-bold text-gray-900 mb-2">
                      {item.title}
                    </h2>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                      {item.description}
                    </p>
                    <button className="text-indigo-600 text-sm font-semibold hover:underline mb-6">
                      Read More
                    </button>
                    
                    <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                      <div className="flex gap-4">
                        <button className="flex items-center gap-1 text-gray-500 hover:text-indigo-600 text-sm">
                          <HandThumbUpIcon className="w-5 h-5" />
                          {item.likes} Like
                        </button>
                        <button className="flex items-center gap-1 text-gray-500 hover:text-indigo-600 text-sm">
                          <ChatBubbleOvalLeftIcon className="w-5 h-5" />
                          {item.comments} Comment
                        </button>
                      </div>
                      <button className="flex items-center gap-1 text-gray-500 hover:text-indigo-600 text-sm">
                        <ShareIcon className="w-5 h-5" />
                        {item.shares} Share
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </div>
          </div>

          {/* Right Sidebar (Ads) - fixed, non-scrollable */}
          <div className="hidden lg:block col-span-2">
            <div className="sticky top-20 h-[calc(100vh-6rem)] overflow-hidden space-y-4">
               <div className="bg-indigo-900 rounded-xl shadow-sm overflow-hidden text-white relative">
               <img 
                 src={require("../../assets/Ad (2).png")}
                 alt="Ad 4"
                 className="w-full h-[50vh] object-cover "
               />
               {/* <div className="absolute inset-0 p-6 flex flex-col justify-center">
                 <p className="text-xs uppercase tracking-wide text-yellow-400 mb-2">Digital Horizons Await</p>
                 <h3 className="text-2xl font-bold mb-4">40% OFF Online Learning & Courses</h3>
                 <button className="bg-yellow-400 text-black px-4 py-2 rounded-full font-bold text-sm w-max hover:bg-yellow-300">
                   GET STARTED TODAY!
                 </button>
               </div> */}
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden relative">
              <button className="absolute top-2 right-2 p-1 bg-white/50 rounded-full hover:bg-white">
                <XMarkIcon className="w-4 h-4 text-gray-600" />
              </button>
              <img
                src={require("../../assets/Ad (3).png")}
                alt="Ad 3"
                className="w-full h-[30vh] object-cover"
              />
              {/* <div className="p-4 bg-orange-50">
                 <h3 className="font-bold text-lg mb-1">Creative Partner for Your Business</h3>
                 <p className="text-xs text-gray-500">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div> */}
            </div>

         
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsFeed;
